export const environment = {
  production: true,
  isEncryptionEnabled: true,
  isDRBuild: false,
  googleMapKey: "AIzaSyB61bMcdCB6ysDuN_OA0hNbHfUydwgBIoU",
   //DEV
  // baseurl : "http://65.1.66.65:9009/jeeth/api/v1/catalog/",

  //CLIENT UAT
  // baseurl: "https://dev.itiamc.com:8485/jeeth/api/v1/catalog/", 
   
  //Prod - Code freezed on 22 July 2021
  baseurl: "https://itiamc.com/jeeth/api/v1/catalog/",
  
  // DR-testing
  // baseurl: "https://drcatalog.itiamc.com/jeeth/api/v1/catalog/",
 
};
